import domain from './domain';
import { resetCurrentPathLocation } from './events';

// Current path location
export const $currentPathLocation = domain.createStore<string>('/').reset(resetCurrentPathLocation);
